"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _serializr = require("serializr");
var _mobx = require("mobx");
var _lodash = require("lodash");
var _utils = require("@seedlang/utils");
var _root_model = _interopRequireDefault(require("./root_model"));
var _date_decorator = _interopRequireDefault(require("./date_decorator"));
var _comment = _interopRequireDefault(require("./comment"));
var _user = _interopRequireDefault(require("./user"));
var _concept_basic = _interopRequireDefault(require("./concept_basic"));
var _feedback = _interopRequireDefault(require("./feedback"));
var _feed_entry_media_item = _interopRequireDefault(require("./feed_entry_media_item"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17; // reminder to not import AppUI to avoid circular dependencies
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var FeedEntry = (_dec = (0, _serializr.serializable)((0, _serializr.object)(_user["default"])), _dec2 = (0, _serializr.serializable)((0, _serializr.object)(_concept_basic["default"])), _dec3 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_comment["default"]))), _dec4 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_feedback["default"]))), _dec5 = (0, _serializr.serializable)((0, _serializr.list)((0, _serializr.object)(_feed_entry_media_item["default"]))), _dec6 = (0, _serializr.serializable)((0, _serializr.custom)(_lodash.noop, function (item) {
  return new _date_decorator["default"](item);
})), _class = /*#__PURE__*/function (_RootModel) {
  function FeedEntry() {
    var _this;
    _classCallCheck(this, FeedEntry);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FeedEntry, [].concat(args));
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "audioUrl", _descriptor2, _this);
    _initializerDefineProperty(_this, "loopSupplement", _descriptor3, _this);
    _initializerDefineProperty(_this, "userId", _descriptor4, _this);
    _initializerDefineProperty(_this, "message", _descriptor5, _this);
    _initializerDefineProperty(_this, "duration", _descriptor6, _this);
    _initializerDefineProperty(_this, "private", _descriptor7, _this);
    _initializerDefineProperty(_this, "muteNotifications", _descriptor8, _this);
    _initializerDefineProperty(_this, "requestFeedback", _descriptor9, _this);
    _initializerDefineProperty(_this, "hasFeedback", _descriptor10, _this);
    _initializerDefineProperty(_this, "languageId", _descriptor11, _this);
    _initializerDefineProperty(_this, "user", _descriptor12, _this);
    _initializerDefineProperty(_this, "concept", _descriptor13, _this);
    _initializerDefineProperty(_this, "comments", _descriptor14, _this);
    _initializerDefineProperty(_this, "likes", _descriptor15, _this);
    _initializerDefineProperty(_this, "feedEntryMediaItems", _descriptor16, _this);
    _initializerDefineProperty(_this, "createdAt", _descriptor17, _this);
    return _this;
  }
  _inherits(FeedEntry, _RootModel);
  return _createClass(FeedEntry, [{
    key: "name",
    get: function get() {
      if ((0, _utils.isPresent)(this.concept)) {
        return this.concept.name;
      }
      return null;
    }
  }, {
    key: "hasVideoClip",
    get: function get() {
      return (0, _utils.isPresent)(this.videoClip);
    }
  }, {
    key: "supplementVideoClip",
    get: function get() {
      return this.translation && this.translation.videoClip || {};
    }
  }, {
    key: "responses",
    get: function get() {
      return this.comments.filter(function (item) {
        return item.commentType === 'response';
      });
    }
  }, {
    key: "transcriptions",
    get: function get() {
      return this.comments.filter(function (item) {
        return item.commentType === 'transcription';
      });
    }
  }, {
    key: "corrections",
    get: function get() {
      return this.comments.filter(function (item) {
        return item.commentType === 'correction';
      });
    }
  }, {
    key: "hasCompositeMedia",
    get: function get() {
      return this.feedEntryMediaItems && this.feedEntryMediaItems.length >= 3;
    }
  }, {
    key: "videoClip",
    get: function get() {
      if (this.feedEntryMediaItems && !this.hasCompositeMedia) {
        var item = this.feedEntryMediaItems[0];
        if (item) {
          return item.videoClip;
        }
      }
      return null;
    }
  }, {
    key: "filteredCommentsCount",
    value: function filteredCommentsCount(user) {
      return this.comments.filter(function (item) {
        return !item.hidden || item.user.id === user.id || user.admin;
      }).length;
    }
  }]);
}(_root_model["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "audioUrl", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "loopSupplement", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "userId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "message", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "duration", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "private", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "muteNotifications", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "requestFeedback", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "hasFeedback", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "languageId", [_mobx.observable, _serializr.serializable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.observable, _dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "concept", [_mobx.observable, _dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "comments", [_mobx.observable, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "likes", [_mobx.observable, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "feedEntryMediaItems", [_mobx.observable, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_mobx.observable, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "name", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "name"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementVideoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementVideoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "responses", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "responses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "transcriptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "transcriptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "corrections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "corrections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCompositeMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCompositeMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "videoClip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoClip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filteredCommentsCount", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "filteredCommentsCount"), _class.prototype), _class);
var _default = exports["default"] = FeedEntry;